import { render, staticRenderFns } from "./student-report.vue?vue&type=template&id=d374e870&scoped=true"
import script from "./student-report.vue?vue&type=script&lang=ts"
export * from "./student-report.vue?vue&type=script&lang=ts"
import style0 from "./student-report.vue?vue&type=style&index=0&id=d374e870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d374e870",
  null
  
)

export default component.exports